import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_06_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-06-01",
    "name": "热身",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["青蛙式、髋关节内旋、抬腿与伟大者伸展热身", "按视频示范控制节奏"],
    "sets": 1,
    "reps": "3分钟",
    "rpe": 3,
    "restSeconds": 0,
    "isBodyweight": true,
    "isWarmup": true,
    "source": "私教跟练 · 第6期",
    "demoUrl": "/media/collections-20261008/demos/24c9e457e7c4f38032776bb8.mp4",
    "videoUrl": "/media/collections-20261008/videos/75978a23dcd3ec2b89149a7a.mp4",
    "targetMuscles": ["髋腿激活肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
  },
  {
    "id": "course-20261008-personal-06-02",
    "name": "小腿训练",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "calves",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腓肠肌", "比目鱼肌"],
    "demoUrl": "/media/collections-20261008/demos/8768868b5f8c1b780ccc4e39.mp4",
    "videoUrl": "/media/collections-20261008/videos/bb6c454854cd4822fc3a7c5b.mp4",
    "source": "私教跟练 · 第6期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-06-03",
    "name": "内收肌训练",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "inner-thigh",
    "tips": ["内收时感受大腿内侧挤压", "控制回放"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第6期",
    "demoUrl": "/media/collections-20261008/demos/dce5c12ee00e6ffa410992af.mp4",
    "videoUrl": "/media/collections-20261008/videos/272d2402a9a357693c115663.mp4",
    "targetMuscles": ["髋内收肌群"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-06-04",
    "name": "保加利亚深蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quads",
    "tips": ["前腿膝盖不超过脚尖", "核心收紧保持平衡"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教跟练 · 第6期",
    "demoUrl": "/media/collections-20261008/demos/20e32c5df832f7cc926e4701.mp4",
    "videoUrl": "/media/collections-20261008/videos/4fab6ba958a42534d27e4f7c.mp4",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "difficulty": "advanced",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-06-05",
    "name": "哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["屈髋主导，感受腘绳肌延展", "腰背全程平直"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 90,
    "isBodyweight": false,
    "source": "私教跟练 · 第6期",
    "demoUrl": "/media/collections-20261008/demos/reviewed-ca7257dda226b54893780cb7.mp4",
    "videoUrl": "/media/collections-20261008/videos/5a17e4dff199d68783a7bb53.mp4",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "difficulty": "advanced",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-06-06",
    "name": "屈髋抬腿",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "hip-flexor",
    "tips": ["核心收紧不塌腰", "感受髋屈肌发力"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第6期",
    "demoUrl": "/media/collections-20261008/demos/2d372e6c656166b3822f2d47.mp4",
    "videoUrl": "/media/collections-20261008/videos/0d3572ca95b53f3e82d0e1f3.mp4",
    "targetMuscles": ["髋屈肌群", "股直肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-06-07",
    "name": "俯身腿弯举",
    "bodyPart": "legs",
    "equipment": "machine",
    "subCategory": "hamstrings",
    "tips": ["臀部贴紧凳面", "感受腘绳肌收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/648f91c510bbb7df35151ca6.mp4",
    "videoUrl": "/media/collections-20261008/videos/8884842e25c19da073602fa5.mp4",
    "targetMuscles": ["腘绳肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第6期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
